import { useState } from 'react'
import { message as $message } from 'antd'
import { getDisplayLabelListAll, queryTileLabels } from '@/services/goods'
import { GoodsFreshmanLabelVo } from '@servicesTypings/marketRequest'

/*
 * 爆款专区商品标签 相关
 * */
export default function useFreshmanLabelList() {
    const [loading, setLoading] = useState(true)
    const [loadingTile, setLoadingTile] = useState(true)
    const [labelList, setLabelList] = useState([])
    const [labelListTile, setLabelListTile] = useState<GoodsFreshmanLabelVo[]>([])

    // 查询佣金规则信息
    const queryLabelList = async () => {
        try {
            const { success, message, data } = await getDisplayLabelListAll()
            if (success) {
                setLabelList(data)
            } else {
                $message.error(message)
            }
        } catch (e) {
            console.error('catchError', e)
        }
        setLoading(false)
    }

    // 查询佣金规则信息(平铺结构)
    const queryLabelListTile = async () => {
        try {
            const { success, message, data } = await queryTileLabels()
            if (success) {
                setLabelListTile(data)
            } else {
                $message.error(message)
            }
        } catch (e) {
            console.error('catchError', e)
        }
        setLoadingTile(false)
    }

    return {
        queryLabelList,
        queryLabelListTile,
        loading,
        loadingTile,
        labelList,
        labelListTile,
    }
}

export type UseFreshmenLabelListResult = ReturnType<typeof useFreshmanLabelList>
